import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * FormField Component (web)
 *
 * A wrapper for label, error, and helper text for form inputs on web.
 * React Native implementation is in FormField.native.tsx.
 */
import React from 'react';
import { useTheme } from '../../theme';
export const FormField = ({ label, error, helperText, required = false, fullWidth = false, children, 'data-testid': testId, className, id, }) => {
    const theme = useTheme();
    const fieldId = id || `form-field-${Math.random().toString(36).substring(2, 11)}`;
    const errorId = error ? `${fieldId}-error` : undefined;
    const helperId = helperText ? `${fieldId}-helper` : undefined;
    const containerStyles = {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing.xs,
        width: fullWidth ? '100%' : 'auto',
    };
    const labelStyles = {
        fontSize: theme.typography.fontSize.small,
        fontWeight: theme.typography.fontWeight.medium,
        color: error ? theme.colors.error : theme.colors.text,
        marginBottom: theme.spacing.xs,
    };
    const helperTextStyles = {
        fontSize: theme.typography.fontSize.caption,
        color: error ? theme.colors.error : theme.colors.textMuted,
        marginTop: theme.spacing.xs,
    };
    const childWithProps = React.isValidElement(children)
        ? React.cloneElement(children, {
            id: fieldId,
            'aria-describedby': [errorId, helperId].filter(Boolean).join(' ') || undefined,
            'aria-invalid': !!error,
            'aria-required': required,
        })
        : children;
    return (_jsxs("div", { style: containerStyles, className: className, "data-testid": testId, children: [label && (_jsxs("label", { htmlFor: fieldId, style: labelStyles, children: [label, required && (_jsx("span", { "aria-label": "required", style: { color: theme.colors.error, marginLeft: '4px' }, children: "*" }))] })), childWithProps, error && (_jsx("div", { id: errorId, role: "alert", style: helperTextStyles, children: error })), helperText && !error && (_jsx("div", { id: helperId, style: helperTextStyles, children: helperText }))] }));
};
FormField.displayName = 'FormField';
